module.exports = __webpack_public_path__ + "media/images/money-bag-e7345523.svg";